import React from "react";
import SlotText from "../../invitation/SlotText";

// The quote: text slots `quoteHeading` / `quoteText`.
//
// `hideTopLines` drops the 10vh vertical accent at the top of the quote
// block. Use it when the section drawn directly above already ends in a
// line of its own (the interlude) so two short vertical lines don't stack
// across the padding gap.
const Testimonial = ({ hideTopLines = false, ...rest }) => {
  return (
    <section
      // data-w-id="4c9e72aa-224e-2766-fd92-6eb6c4a3525c"
      className="section home-testi"
      {...rest}
    >
      <div className="container">
        <div className="quote-div">
          {!hideTopLines && (
            <div className="vert-line _10vh mbm-exclusion pad-15"></div>
          )}
          <div className="pad-15">
            <SlotText
              slot="quoteHeading"
              as="p"
              className="heading-38"
              style={{ paddingBottom: "16px" }}
            />
            <SlotText slot="quoteText" as="p" className="made-22" />
          </div>
          {/* <div className="vert-line _10vh mbm-exclusion"></div>
          <div className="signature">Timeless memories</div> */}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
